export class BOPrescriptionMedicationDose{
    id:number;
    quantity:number;
    measurementMedicationUnits:string;
}